import { TrendAnomalyExcursion } from 'src/app/_shared/interface/trend-anomaly.interface';

export enum ChartKeyType {
  TREND_ANOMALY_EXCURSION = 'TrendAnomalyExcursionChart',
}

/**
 * List of chart key config types
 */
export type ChartKeyConfigTypes = TrendAnomalyExcursionChartConfig;

/**
 * Object required to construct TrendAnomalyExcursionChart
 */
export interface TrendAnomalyExcursionChartConfig {
  chartKeyType: ChartKeyType.TREND_ANOMALY_EXCURSION;
  excursions: TrendAnomalyExcursion[];
  name: string;
}
